/**
 * Products Scroll – GSAP ScrollTrigger Horizontal Scroll
 * Combined with Products Hero on the same horizontal axis.
 *
 * Behavior (desktop only, >991px):
 * 1. Products Hero fills the viewport as the first "panel"
 * 2. When the hero reaches the top, it pins in place
 * 3. Product slides scroll in horizontally from the right
 * 4. After all slides pass, pinning releases and vertical scroll resumes
 *
 * On tablet/mobile (≤991px), falls back to vertical grid layout.
 */

(function () {
  'use strict';

  function initProductsScroll(sectionEl) {
    var wrapper = sectionEl.querySelector('.products-scroll');
    if (!wrapper) return;

    var track = wrapper.querySelector('.products-scroll__track');
    if (!track) return;

    var slides = wrapper.querySelectorAll('.products-scroll__slide');
    if (slides.length < 2) return;

    /* ============================================
       Quick-add modal logic (runs on ALL viewports)
       ============================================ */

    slides.forEach(function (slide) {
      var toggleBtn = slide.querySelector('[data-ps-toggle]');
      var modal = slide.querySelector('[data-ps-modal]');
      if (!toggleBtn || !modal) return;

      var isDesktop = window.innerWidth > 991;

      if (isDesktop) {
        /* Desktop: click anywhere on the card opens/closes modal */
        slide.addEventListener('click', function (e) {
          /* Only skip toggle for interactive form controls inside the modal */
          var interactive = e.target.closest('select, input, [data-ps-qty-minus], [data-ps-qty-plus], [data-ps-atc], a.ps-modal__view-details, .ps-modal__variant-select-wrap');
          if (interactive && modal.contains(interactive)) return;
          e.preventDefault();
          slide.classList.toggle('is-modal-open');
        });
      } else {
        /* Mobile: click on + button (existing) */
        toggleBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          slide.classList.toggle('is-modal-open');
        });
        /* Mobile: click on tags or title text also opens/closes modal */
        var contentTags = slide.querySelector('.products-scroll__content .products-scroll__tags');
        var contentTitle = slide.querySelector('.products-scroll__content .products-scroll__title');
        var modalTags = slide.querySelector('.products-scroll__modal .products-scroll__tags');
        var modalTitle = slide.querySelector('.products-scroll__modal-title');
        [contentTags, contentTitle, modalTags, modalTitle].forEach(function (el) {
          if (!el) return;
          el.style.cursor = 'pointer';
          el.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            slide.classList.toggle('is-modal-open');
          });
        });
      }

      var variantsJson = modal.querySelector('[data-ps-variants]');
      var variantIdInput = modal.querySelector('[data-ps-variant-id]');
      var optionSelects = modal.querySelectorAll('[data-ps-option]');
      var variants = [];

      if (variantsJson) {
        try { variants = JSON.parse(variantsJson.textContent); } catch (err) { /* noop */ }
      }

      function matchVariant() {
        var selectedOptions = [];
        optionSelects.forEach(function (sel) {
          selectedOptions.push(sel.value);
        });
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (v.options[j] !== selectedOptions[j]) {
              match = false;
              break;
            }
          }
          if (match) {
            variantIdInput.value = v.id;
            return;
          }
        }
      }

      optionSelects.forEach(function (sel) {
        sel.addEventListener('change', matchVariant);
      });

      var qtyInput = modal.querySelector('[data-ps-qty]');
      var formQty = modal.querySelector('[data-ps-form-qty]');
      var minusBtn = modal.querySelector('[data-ps-qty-minus]');
      var plusBtn = modal.querySelector('[data-ps-qty-plus]');

      if (qtyInput && minusBtn && plusBtn) {
        minusBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val > 1) {
            qtyInput.value = val - 1;
            if (formQty) formQty.value = val - 1;
          }
        });
        plusBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val < 99) {
            qtyInput.value = val + 1;
            if (formQty) formQty.value = val + 1;
          }
        });
        qtyInput.addEventListener('change', function () {
          var val = Math.max(1, Math.min(99, parseInt(qtyInput.value, 10) || 1));
          qtyInput.value = val;
          if (formQty) formQty.value = val;
        });
      }

      var cartForm = modal.querySelector('[data-ps-cart-form]');
      var atcBtn = modal.querySelector('[data-ps-atc]');
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      if (cartForm) {
        cartForm.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!atcBtn) return;

          var originalText = atcBtn.textContent;
          atcBtn.textContent = 'Adding...';
          atcBtn.disabled = true;

          var config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          var formData = new FormData();
          formData.append('id', variantIdInput.value);
          formData.append('quantity', formQty ? formQty.value : '1');

          if (cart && typeof cart.getSectionsToRender === 'function') {
            formData.append('sections', cart.getSectionsToRender().map(function (section) {
              return section.id;
            }));
            formData.append('sections_url', window.location.pathname);
          }

          config.body = formData;

          fetch(routes.cart_add_url, config)
          .then(function (res) { return res.json(); })
          .then(function (response) {
            if (response.status) {
              throw new Error(response.description || response.message || 'Add to cart failed');
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'products-scroll',
                productVariantId: formData.get('id'),
                cartData: response
              });
            }

            if (cart.tagName === 'CART-DRAWER') {
              cart.renderContents(response, {
                source: 'products-scroll',
                forceOpenOnHomepage: true
              });
            } else {
              cart.renderContents(response);
            }

            atcBtn.textContent = 'Added ✓';
            setTimeout(function () {
              atcBtn.textContent = originalText;
              atcBtn.disabled = false;
            }, 1500);
          })
          .catch(function () {
            atcBtn.textContent = 'Error - retry';
            atcBtn.disabled = false;
            setTimeout(function () {
              atcBtn.textContent = originalText;
            }, 2000);
          });
        });
      }
    });

    /* ============================================
       On tablet/mobile, skip horizontal scroll
       ============================================ */
    if (window.innerWidth <= 991) {
      track.style.width = '100%';
      wrapper.style.setProperty('--ps-track-width', '100%');
      return;
    }

    /* ============================================
       Desktop: Combined Hero + Products Scroll
       ============================================ */

    var dots = wrapper.querySelectorAll('.products-scroll__dot');

    /* Find the hero section (preceding sibling) */
    var heroSection = sectionEl.previousElementSibling;
    var hasHero = heroSection && heroSection.classList.contains('section-products-hero');

    /* Register ScrollTrigger plugin */
    gsap.registerPlugin(ScrollTrigger);

    /* Calculate dimensions */
    var totalSlides = slides.length;
    var slideWidth = window.innerWidth / 2;

    /* Set track CSS width (flex container needs enough space) */
    track.style.width = (totalSlides * 50) + 'vw';
    wrapper.style.setProperty('--ps-track-width', (totalSlides * 50) + 'vw');

    /* Measure actual visual width from first to last slide edge
       (accounts for CSS margin-left: -2px on adjacent slides) */
    var firstRect = slides[0].getBoundingClientRect();
    var lastRect = slides[slides.length - 1].getBoundingClientRect();
    var trackWidth = lastRect.right - firstRect.left + 2; /* +2 for last slide right margin */

    if (hasHero) {
      /* ---- Combined mode: Hero + Scroll on same horizontal axis ---- */

      /* Mark elements for CSS hooks */
      sectionEl.classList.add('ps-combined-mode');
      heroSection.classList.add('ps-combined-hero');

      /*
       * Strategy:
       * Create a horizontal container that holds the hero (100vw) and the
       * product track side-by-side. Pin the outer wrapper and translate
       * the inner container leftward so both hero and products scroll
       * together on one horizontal axis.
       *
       * Layout: [ HERO (100vw) ][ SLIDE 1 (50vw) ][ SLIDE 2 (50vw) ] ...
       * Total width = 100vw + totalSlides * 50vw
       * Scroll distance = totalWidth - 100vw (what needs to move off-screen)
       */

      var heroWidth = window.innerWidth;
      var totalWidth = heroWidth + trackWidth;
      var scrollDistance = totalWidth - window.innerWidth;

      /* Create the combined horizontal container */
      var combinedTrack = document.createElement('div');
      combinedTrack.className = 'ps-combined-track';
      combinedTrack.style.display = 'flex';
      combinedTrack.style.width = totalWidth + 'px';
      combinedTrack.style.height = '100vh';
      combinedTrack.style.flexShrink = '0';

      /* Create a pin wrapper that clips the combined track */
      var pinWrapper = document.createElement('div');
      pinWrapper.className = 'ps-combined-pin';
      pinWrapper.style.width = '100vw';
      pinWrapper.style.height = '100vh';
      pinWrapper.style.overflow = 'hidden';
      pinWrapper.style.position = 'relative';
      pinWrapper.style.zIndex = '2';

      /* Clone the hero content into a panel for the track */
      var heroInner = heroSection.querySelector('.products-hero');
      var heroPanel = document.createElement('div');
      heroPanel.className = 'ps-combined-hero-panel';
      heroPanel.style.flex = '0 0 100vw';
      heroPanel.style.width = '100vw';
      heroPanel.style.height = '100vh';
      heroPanel.style.position = 'relative';
      heroPanel.style.overflow = 'hidden';

      /* Move hero's children into the hero panel */
      while (heroInner.firstChild) {
        heroPanel.appendChild(heroInner.firstChild);
      }

      /* Style the scroll section for inline placement */
      sectionEl.style.flex = '0 0 auto';
      sectionEl.style.width = trackWidth + 'px';
      sectionEl.style.height = '100vh';
      sectionEl.style.margin = '0';
      sectionEl.style.position = 'relative';

      wrapper.style.height = '100vh';
      wrapper.style.overflow = 'visible';
      wrapper.style.width = trackWidth + 'px';

      track.style.height = '100vh';

      /* Assemble: pinWrapper > combinedTrack > [ heroPanel, sectionEl ] */
      combinedTrack.appendChild(heroPanel);
      combinedTrack.appendChild(sectionEl);
      pinWrapper.appendChild(combinedTrack);

      /* Insert pin wrapper where the hero section was */
      heroSection.parentNode.insertBefore(pinWrapper, heroSection);
      heroSection.style.display = 'none';

      /* GSAP: pin the wrapper, translate the combined track left */
var pauseDuration = 0.1; // 20% cuối sẽ là pause (tăng để dừng lâu hơn)
var animDuration = 1 - pauseDuration; // 80% đầu là horizontal scroll

var tl = gsap.timeline({
  scrollTrigger: {
    trigger: pinWrapper,
    pin: true,
    pinSpacing: true,
    scrub: 1,
    start: 'top top',
    end: function () { return '+=' + (scrollDistance / animDuration); },
    invalidateOnRefresh: true,
    onUpdate: function (self) {
      if (dots.length > 0) {
        var progress = self.progress;
        /* Adjust dot progress to account for hero panel and pause duration */
        var adjustedProgress = Math.min(progress / animDuration, 1);
        var slideProgress = Math.max(0, (adjustedProgress * totalWidth - heroWidth) / trackWidth);
        var activeIndex = Math.min(totalSlides - 1, Math.round(slideProgress * (totalSlides - 1)));
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === activeIndex);
        });
      }
    }
  }
});

// Horizontal scroll animation (80% of timeline)
tl.to(combinedTrack, {
  x: -scrollDistance,
  ease: 'none',
  duration: animDuration
});

// Hold/pause at the end (20% of timeline)
tl.to(combinedTrack, {
  x: -scrollDistance, // Giữ nguyên vị trí
  ease: 'none',
  duration: pauseDuration
});

var scrollTween = tl;

      /* Staggered entry animations for each slide */
      slides.forEach(function (slide) {
        var tags = slide.querySelector('.products-scroll__tags');
        var title = slide.querySelector('.products-scroll__title');
        var imgWrap = slide.querySelector('.products-scroll__image-wrap');
        var viewMore = slide.querySelector('.products-scroll__view-more');
        var elements = [tags, title, imgWrap, viewMore].filter(Boolean);

        gsap.from(elements, {
          y: 40,
          opacity: 0,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: slide,
            containerAnimation: scrollTween,
            start: 'left 80%',
            end: 'left 30%',
            toggleActions: 'play none none reverse'
          }
        });
      });

      wrapper._scrollTween = scrollTween;


    } else {
      /* ---- Standalone mode: original behavior ---- */
      var scrollDistance = trackWidth - window.innerWidth;

      var scrollTween = gsap.to(track, {
        x: function () { return -scrollDistance; },
        ease: 'none',
        scrollTrigger: {
          trigger: wrapper,
          pin: true,
          scrub: 1,
          end: function () { return '+=' + scrollDistance; },
          invalidateOnRefresh: true,
          onUpdate: function (self) {
            if (dots.length > 0) {
              var progress = self.progress;
              var activeIndex = Math.round(progress * (totalSlides - 1));
              dots.forEach(function (dot, i) {
                dot.classList.toggle('is-active', i === activeIndex);
              });
            }
          }
        }
      });

      slides.forEach(function (slide, index) {
        if (index === 0) return;
        var tags = slide.querySelector('.products-scroll__tags');
        var title = slide.querySelector('.products-scroll__title');
        var imgWrap = slide.querySelector('.products-scroll__image-wrap');
        var viewMore = slide.querySelector('.products-scroll__view-more');
        var elements = [tags, title, imgWrap, viewMore].filter(Boolean);

        gsap.from(elements, {
          y: 40,
          opacity: 0,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: slide,
            containerAnimation: scrollTween,
            start: 'left 80%',
            end: 'left 30%',
            toggleActions: 'play none none reverse'
          }
        });
      });

      wrapper._scrollTween = scrollTween;
    }

    /* Set first dot active */
    if (dots.length > 0) {
      dots[0].classList.add('is-active');
    }

    /* Handle window resize */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        ScrollTrigger.refresh();
      }, 250);
    });
  }

  /* ---- Wait for GSAP ---- */
  function waitForGSAP(callback) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      callback();
    } else {
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
          clearInterval(interval);
          callback();
        } else if (attempts > 100) {
          clearInterval(interval);
          console.warn('[Products Scroll] GSAP or ScrollTrigger not loaded');
        }
      }, 50);
    }
  }

  /* ---- Bootstrap ---- */
  function init() {
    document.querySelectorAll('.section-products-scroll').forEach(function (section) {
      initProductsScroll(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForGSAP(init);
    });
  } else {
    waitForGSAP(init);
  }

  /* ---- Theme editor support ---- */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target;
      if (section.querySelector('.products-scroll')) {
        var wrapper = section.querySelector('.products-scroll');
        if (wrapper._scrollTween) {
          wrapper._scrollTween.scrollTrigger.kill();
          wrapper._scrollTween.kill();
        }
        waitForGSAP(function () {
          initProductsScroll(section);
        });
      }
    });
  }
})();
